import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customerActions } from "stores/customer/customerActions";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";

const mapStateToProps = (state) => {
  return {
    deviceId: state.common.deviceId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthDataAction: customerActions.updateAuthData,
      updateOnboardingDataAction: onboardingActions.updateOnboardingData,
      updateOnestockOnboardingDataAction:
        jarvsiOnestockOnboardingActions.updateOnestockOnboardingData,
      updatePrimeOnboardingDataAction:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      updateSentimentTrackerOnboardingDataAction:
        sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData,
      updateRMSOnboardingDataAction:
        jarvsiRMSOnboardingActions.updateRMSOnboardingData,
      updatePHCOnboardingDataAction:
        PHCOnboardingActions.updatePHCOnboardingData,
      updateAuthStatus: customerActions.updateAuthStatus,
    },
    dispatch
  );

const SignUpStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default SignUpStore;
